import { get } from "lodash";

const usableName = (value) => {
  if (value === null || value === undefined) return "";
  const text = String(value).trim();
  return text.toLowerCase() === "null" ? "" : text;
};

/** A company contact is named after its organization, a person after the user. */
export const contactDisplayName = (contact) => {
  const organizationName = usableName(get(contact, "organization.name"));
  if (organizationName) return organizationName;
  return [get(contact, "user.firstname"), get(contact, "user.lastname")]
    .map(usableName)
    .filter(Boolean)
    .join(" ");
};

export const contactInitials = (contact) => {
  const organizationName = usableName(get(contact, "organization.name"));
  if (organizationName) return organizationName.substring(0, 2).toUpperCase();
  return [get(contact, "user.firstname"), get(contact, "user.lastname")]
    .map((part) => usableName(part).substring(0, 1))
    .join("");
};
